import React from "react";
import Truther from "./Components/Truther";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div>
          <Truther />
        </div>
      </header>
    </div>
  );
}

export default App;
